import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CatalogContainer, ProductContainer, Sidebar } from './styles';
import SearchBar from '../../../../components/Purchase/SearchBar';
import Filters from '../../../../components/Purchase/Filters';
import { FiltersProvider } from '../../../../providers/filters.provider';
import { ShoppingCartBottomBar } from '../../../../components/Purchase/BottomBar';
import { ApplicationState } from '../../../../store';
import { BlockedModal } from '../../../../components/Purchase/BlockedModal';
import { useDispatch } from 'react-redux';
import { cleanShoppingCart } from '../../../../store/ducks/long-steel-shopping-cart/actions';
import { useCatalogService } from '../../../../services/MVP/useCatalogService';
import {
  ProductDescription,
  ProductType,
  SearchOptionsProps,
  SortProductsItem,
  SortProductsProps,
  ValidationModalProps
} from '../../../../services/MVP/models';
import LoadingModal from '../../../../components/LoadingModal';
import { ITaggingParams } from '../../../../store/ducks/tagging/types';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { GridContainer } from '../../../../components/Purchase/GridContainer';
import ProductCard from '../../../../components/Purchase/ProductCard';
import { PaginationContainer } from '../ShoppingCartMVP/style';
import { Pagination } from '@gerdau/hefesto-mais-web';
import { updateCartItemsQuantity } from '../../../../store/ducks/cart-items-mvp/actions';
import { useCartService } from '../../../../services/MVP/useCartService';
import { useLocation } from 'react-router-dom';
import MessageChooseItem from '../../../../components/MessageChooseItem';
import { ValidationModal } from '../ShoppingCartMVP/ValidationModal';

interface IfilterTaggingObject {
  event: string;
  screenName: string;
  etapa: string;
  cod_produto: string;
  ordernation: string;
  [key: string]: string;
}

const CatalogPagination = ({
  handleChange,
  total,
  selectedPage
}: {
  handleChange: (page: number, size: number) => void;
  total: number;
  selectedPage: number;
}) => {
  return (
    <PaginationContainer disableNextPage={total <= 12}>
      <Pagination
        ariaLabel="pagination"
        onChange={(page: number, pageTotal: number) =>
          total <= 12 ? null : handleChange(page, pageTotal)
        }
        total={total}
        showTotal
        selectedPage={selectedPage}
        pageSizeOptions={[12, 24]}
      />
    </PaginationContainer>
  );
};

const CatalogPage = () => {
  const { sortProducts, searchProducts, productsTypes } = useCatalogService();
  const { getCartItemQuantity } = useCartService();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gpd = searchParams.get('gpd')?.trim();
  // TODO: Integrações com magento, estado sem BP selecionado, estado de página vazio, estado de loading
  const { emitterId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );
  const {
    customers,
    loading,
    loadingProductDescription,
    loadingPurchaseReceivers,
    loadingBlocks,
    loadingCustomerById
  } = useSelector((state: ApplicationState) => state.customers);
  const selectedCustomer = customers.find((c) => c.customerId === emitterId);

  // determinar quais blocks são os que determinam o block "completo"
  // https://www.figma.com/design/9VmG6NHIGVlFa5KsN27fjI/Jornada-de-cota%C3%A7%C3%A3o-e-compra?node-id=2916-44390&t=TfhQN7FwW5LlVwyJ-4
  const isBlockedCustomer =
    selectedCustomer?.blocks &&
    selectedCustomer?.blocks?.filter((blc) => blc.type === 'order')?.length > 0;

  const descricao_gpm = (product: SortProductsItem) => {
    return (
      product.custom_attributes.find(
        (att: { attribute_code: string }) =>
          att.attribute_code === 'descricao_gpm'
      )?.value ?? ''
    );
  };

  const [openBlockedModal, setOpenBlockedModal] = useState(isBlockedCustomer);
  const [productsTypesList, setProductsTypesList] = useState<ProductType[]>();
  const [searchDataAC, setSearchDataAC] = useState<ProductDescription[]>([]);
  const [searchOptions, setSearchOptions] = useState<SearchOptionsProps>({
    filters: {
      materialCode: 'gerdauCode',
      ordenation: 'R',
      productsTypes: [''],
      input: gpd ?? ''
    },
    pagination: {
      currentPage: 1,
      pageSize: 12
    }
  });
  const [validationModalInformation, setValidationModalInformation] =
    useState<ValidationModalProps>({
      show: false,
      title: '',
      description: '',
      handleNextBtn: () => null,
      handleNextBtnTitle: 'Continuar',
      hiddenLeftButton: false
    });

  const handleCloseValidationModal = () => {
    setValidationModalInformation((prev) => ({
      ...prev,
      show: false
    }));
  };

  const [products, setProducts] = useState<{
    products: SortProductsItem[];
    total: number;
  }>();
  const [sortLoading, setSortLoading] = useState(true);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onCloseBlockedModal = () => {
    dispatch(cleanShoppingCart());
    setOpenBlockedModal(false);
  };

  const customerLoading =
    loading ||
    !!loadingProductDescription ||
    !!loadingPurchaseReceivers ||
    !!loadingBlocks ||
    !!loadingCustomerById;

  const pageLoading = sortLoading || customerLoading;

  const getSortProducts = async ({
    options,
    products,
    showLoading = true,
    scrollToTopEnabled = true
  }: {
    options: SearchOptionsProps;
    products?: ProductDescription[];
    showLoading?: boolean;
    scrollToTopEnabled?: boolean;
  }) => {
    if (
      !customerLoading &&
      emitterId &&
      selectedCustomer &&
      !isBlockedCustomer &&
      selectedCustomer?.productsDescriptionResponse
    ) {
      if (showLoading) {
        setSortLoading(true);
      }

      const data = await sortProducts({
        sortType: options.filters.ordenation,
        pageSize: options.pagination.pageSize,
        ...((!products ||
          ['R', 'AC'].includes(options.filters.ordenation ?? '')) && {
          currentPage: options.pagination.currentPage
        }),
        ...(products && { productsSearch: products }),
        options
      });
      if (data.hasError) {
        setValidationModalInformation({
          title: 'Serviço indisponível temporariamente',
          description:
            'Tente novamente mais tarde ou entre em contato com o seu vendedor.',
          show: true,
          hiddenLeftButton: true,
          handleNextBtn: handleCloseValidationModal,
          handleNextBtnTitle: 'Continuar'
        });
        scrollToTop();
        setSortLoading(false);
        return;
      }
      setSearchOptions((prev) => ({ ...prev, ...options }));
      if (scrollToTopEnabled) {
        scrollToTop();
      }
      setSortLoading(false);
      return data;
    }
  };

  const getSearchProducts = async (options: SearchOptionsProps) => {
    if (
      !customerLoading &&
      emitterId &&
      selectedCustomer &&
      !isBlockedCustomer &&
      selectedCustomer?.productsDescriptionResponse
    ) {
      setSortLoading(true);
      setSearchOptions(options);
      scrollToTop();
      const hasProductsTypes =
        options.filters.productsTypes &&
        options.filters.productsTypes.filter((f) => f.length > 0);
      const hasInputSearch =
        options.filters.input && options.filters.input.length > 0;

      if (options.filters.materialCode === 'gerdauCode') {
        const data = await searchProducts({
          ...(hasProductsTypes && {
            sap_descricao_gpm: options.filters.productsTypes?.filter(
              (f) => f.length > 0
            )
          }),
          ...(hasInputSearch && {
            sku: options.filters.input
          }),
          ...(options.filters.ordenation === 'AC' && {
            searchType: 'AC'
          }),
          sortType: options.filters.ordenation,
          currentPage: options.pagination.currentPage,
          pageSize: options.pagination.pageSize
        });
        setSortLoading(false);
        return data;
      } else {
        const data = await searchProducts({
          ...(hasProductsTypes && {
            sap_descricao_gpm: options.filters.productsTypes?.filter(
              (f) => f.length > 0
            )
          }),
          ...(hasInputSearch && {
            internalCode: options.filters.input
          }),
          ...(options.filters.ordenation === 'AC' && {
            searchType: 'AC'
          }),
          sortType: options.filters.ordenation,
          currentPage: options.pagination.currentPage,
          pageSize: options.pagination.pageSize
        });
        setSortLoading(false);
        return data;
      }
    }
  };

  const handlePagination = async (currentPage = 1, pageSize = 12) => {
    if (products?.products && products?.products?.length > 0 && sortLoading) {
      return null;
    }
    if (
      searchOptions.filters.ordenation &&
      ['R', 'AC'].includes(searchOptions.filters.ordenation) &&
      !gpd?.length
    ) {
      const sortResponse = await getSortProducts({
        options: {
          ...searchOptions,
          pagination: { currentPage, pageSize }
        },
        products: searchDataAC ?? []
      });
      setProducts({
        products: sortResponse?.products ?? [],
        total: sortResponse?.total ?? 0
      });

      setSortLoading(false);

      // setTimeout(async () => {
      //   const nextPage = currentPage + 1;

      //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
      //   const secondSortResponse = await getSortProducts({
      //     options: {
      //       ...searchOptions,
      //       pagination: { currentPage: nextPage, pageSize }
      //     },
      //     products: searchDataAC ?? [],
      //     showLoading: false,
      //     scrollToTopEnabled: false
      //   });
      // }, 0);
    } else {
      const searchData = await getSearchProducts({
        ...searchOptions,
        pagination: {
          currentPage,
          pageSize
        }
      });
      const sortResponse = await getSortProducts({
        options: {
          ...searchOptions,
          pagination: {
            // Enviar página 0 pois a sort nao buscará mais produtos
            currentPage: 0,
            pageSize
          }
        },
        products: searchData?.products
      });
      setProducts({
        products: sortResponse?.products ?? [],
        total:
          searchOptions.filters.ordenation === 'AB'
            ? searchData?.total ?? 0
            : sortResponse?.total ?? 0
      });
      setSortLoading(false);
    }
  };

  const handleSortChange = async (order: SortProductsProps['sortType']) => {
    if (order === 'R') {
      const sortResponse = await getSortProducts({
        options: {
          ...searchOptions,
          pagination: {
            ...searchOptions.pagination,
            currentPage: 1
          },
          filters: {
            ...searchOptions.filters,
            ordenation: order
          }
        }
      });
      setProducts({
        products: sortResponse?.products ?? [],
        total: sortResponse?.total ?? 0
      });
    } else if (order === 'AB') {
      const searchData = await getSearchProducts({
        ...searchOptions,
        pagination: {
          ...searchOptions.pagination,
          currentPage: 1
        },
        filters: {
          ...searchOptions.filters,
          ordenation: order
        }
      });
      const sortResponse = await getSortProducts({
        products: searchData?.products,
        options: {
          ...searchOptions,
          pagination: {
            ...searchOptions.pagination,
            currentPage: 1
          },
          filters: {
            ...searchOptions.filters,
            ordenation: order
          }
        }
      });
      setProducts({
        products: sortResponse?.products ?? [],
        total: searchData?.total ?? 0
      });
    } else {
      // Caso de ordenação por acordo de preço
      // Ainda está sendo ajustada (31/08/2024)
      const searchData = await getSearchProducts({
        ...searchOptions,
        pagination: {
          ...searchOptions.pagination,
          currentPage: 1
        },
        filters: {
          ...searchOptions.filters,
          ordenation: order
        }
      });

      const sortResponse = await getSortProducts({
        options: {
          ...searchOptions,
          pagination: {
            ...searchOptions.pagination,
            currentPage: 1
          },
          filters: {
            ...searchOptions.filters,
            ordenation: order
          }
        },
        products: searchData?.products
      });
      setSearchDataAC(searchData?.products ?? []);
      setProducts({
        products: sortResponse?.products ?? [],
        total: sortResponse?.total ?? 0
      });
    }
  };

  const handleSearchChange = async (
    value: SearchOptionsProps['filters'],
    noChanges?: boolean
  ) => {
    if (noChanges) {
      setSearchOptions((prev) => ({ ...prev, filters: value }));
      return;
    }
    const searchData = await getSearchProducts({
      ...searchOptions,
      pagination: {
        ...searchOptions.pagination,
        currentPage: 1
      },
      filters: {
        ...searchOptions.filters,
        ...value
      }
    });
    const sortResponse = await getSortProducts({
      options: {
        ...searchOptions,
        pagination: {
          ...searchOptions.pagination,
          currentPage: 1
        },
        filters: {
          ...searchOptions.filters,
          ...value
        }
      },
      products: searchData?.products
    });

    setProducts({
      products: sortResponse?.products ?? [],
      total:
        searchOptions.filters.ordenation === 'AB'
          ? searchData?.total ?? 0
          : sortResponse?.total ?? 0
    });
  };

  useEffect(() => {
    localStorage.setItem('tipo_compra', 'vitrine');
    const viewItemListTagging: ITaggingParams = {
      event: 'view_item_list',
      ecommerce: {
        screenName: 'comprar_por_vitrine',
        tipo_compra: 'vitrine',
        paginacao: searchOptions.pagination.currentPage.toString() ?? '',
        items: Array.isArray(products?.products)
          ? products?.products
              .filter((prd) => prd.id)
              .map((prd) => ({
                screenName: 'vitrine',
                price: prd.price?.creditPrice,
                unidade_de_medida: prd.price?.um,
                item_id: `${prd.sku}`,
                item_name: prd.name,
                tipo_compra: localStorage.getItem('tipo_compra') ?? '',
                item_category: descricao_gpm(prd),
                cod_gerdau: prd.sku,
                preco_acordado: prd.price?.isAgreementPrice.length > 0,
                quantity: '1'
              }))
          : []
      }
    };
    if (
      products &&
      Array.isArray(products?.products) &&
      products?.products.length > 0
    ) {
      filterVisibleProducts(viewItemListTagging);
    }
  }, [products]);

  function filterVisibleProducts(viewItemListTagging: ITaggingParams) {
    const itemListEvent = viewItemListTagging;

    if (
      !itemListEvent ||
      !itemListEvent.ecommerce ||
      !itemListEvent.ecommerce.items
    ) {
      return;
    }

    const productElements = document.querySelectorAll('.product-cards');

    const observer = new IntersectionObserver(
      function (entries) {
        const visibleProducts: any[] = [];

        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const productIndex = Array.prototype.indexOf.call(
              productElements,
              entry.target
            );

            if (itemListEvent.ecommerce?.items) {
              const productData = itemListEvent.ecommerce.items[productIndex];

              if (productData && visibleProducts.indexOf(productData) === -1) {
                visibleProducts.push(productData);
              }
            }
          }
        });

        if (visibleProducts.length > 0) {
          window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
              screenName: 'comprar_por_vitrine',
              tipo_compra: 'vitrine',
              paginacao: searchOptions.pagination.currentPage.toString(),
              items: visibleProducts
            }
          });
        }
      },
      {
        threshold: 0.5
      }
    );

    productElements.forEach(function (product, i) {
      observer.observe(product);
    });
  }

  const filterTaggingObject: IfilterTaggingObject = {
    event: 'filtros_vitrine',
    screenName: 'comprar_por_vitrine',
    etapa: 'lista_de_produtos',
    cod_produto: searchOptions.filters.materialCode ?? '',
    ordernation: searchOptions.filters.ordenation ?? ''
  };
  useEffect(() => {
    searchOptions.filters.productsTypes
      ?.filter((f) => f.length !== 0)
      .forEach((f, i) => {
        filterTaggingObject[`filtro_${i}`] = f;
      });

    if (
      (searchOptions.filters.productsTypes?.length ?? 0) > 0 &&
      (searchOptions.filters.productsTypes![0] ?? ' ') != ''
    ) {
      dispatch(sendTagging(filterTaggingObject));
    }
  }, [
    searchOptions.filters.materialCode,
    searchOptions.filters.ordenation,
    searchOptions.filters.productsTypes
  ]);

  const filterTaggingProducNotFound: ITaggingParams = {
    event: 'nenhum_produto_encontrado',
    screenName: 'comprar_por_vitrine',
    termo_pesquisado: searchOptions.filters.input ?? '',
    filtros:
      searchOptions.filters.materialCode +
      ',' +
      searchOptions.filters.ordenation +
      ',' +
      (searchOptions.filters.productsTypes?.toString() ?? '')
  };

  useEffect(() => {
    if (products?.products.length === 0 && !pageLoading) {
      dispatch(sendTagging(filterTaggingProducNotFound));
    }
  }, [searchOptions.filters, products]);

  useEffect(() => {
    setOpenBlockedModal(isBlockedCustomer);
  }, [selectedCustomer]);

  useEffect(() => {
    const loadQuantity = async () => {
      if (
        !customerLoading &&
        emitterId &&
        selectedCustomer &&
        !isBlockedCustomer &&
        selectedCustomer?.productsDescriptionResponse
      ) {
        const productsTypesData = await productsTypes();
        if (!productsTypesData || productsTypesData.length === 0) {
          throw new Error();
        }
        setProductsTypesList(productsTypesData ?? []);
        // const cartQuantity = await getCartItemQuantity();
        // dispatch(updateCartItemsQuantity(cartQuantity));
      }
    };
    (async () => {
      try {
        setSortLoading(true);
        await loadQuantity();
        await handlePagination();
      } catch (error) {
        console.error(error);
      } finally {
        setSortLoading(false);
      }
    })();
  }, [customerLoading, emitterId]);

  if (!loading && (!emitterId || !selectedCustomer || isBlockedCustomer)) {
    return (
      <>
        {openBlockedModal && (
          <BlockedModal onCloseModal={onCloseBlockedModal} />
        )}
        <MessageChooseItem message="Selecione emissor e recebedor para continuar."></MessageChooseItem>
      </>
    );
  }

  return (
    <>
      <LoadingModal
        enabled={pageLoading}
        title="Aguarde alguns instantes"
        message="Carregando os dados..."
      />
      <ValidationModal
        {...validationModalInformation}
        loading={loading}
        handleCloseValidationModal={handleCloseValidationModal}
      />

      <FiltersProvider>
        <CatalogContainer>
          <Sidebar>
            <Filters
              handleSearchChange={handleSearchChange}
              searchOptions={searchOptions}
              sortLoading={sortLoading}
              handleSortChange={handleSortChange}
              productsTypesList={productsTypesList ?? []}
              key={emitterId}
            />
          </Sidebar>
          <ProductContainer>
            <SearchBar
              handleSearchChange={handleSearchChange}
              searchOptions={searchOptions}
              key={searchOptions.filters.materialCode}
              setLoading={setSortLoading}
            />
            <GridContainer gap="1.5rem">
              {products &&
                products?.products &&
                Array.isArray(products?.products) &&
                products?.products.map((prd) => {
                  if (!prd.id) {
                    return null;
                  }
                  const agreementPrice =
                    prd.price?.isAgreementPrice.length !== 0;
                  const image = prd.media_gallery_entries?.[0]?.file
                    ? {
                        desktopSource: `${process.env.REACT_APP_MEDIA_BASE_URL}/media/catalog/product/${prd.media_gallery_entries[0].file}`
                      }
                    : undefined;

                  return (
                    <ProductCard
                      key={prd.sku}
                      agreedPrice={agreementPrice}
                      image={image}
                      product={prd}
                      typeCode={searchOptions.filters.materialCode}
                    />
                  );
                })}
            </GridContainer>

            <CatalogPagination
              handleChange={handlePagination}
              total={products?.total ?? 0}
              selectedPage={searchOptions.pagination.currentPage}
              key={JSON.stringify(searchOptions.filters.productsTypes)}
            />
          </ProductContainer>
        </CatalogContainer>
      </FiltersProvider>
      <ShoppingCartBottomBar loading={pageLoading} />
    </>
  );
};
export default CatalogPage;
